export default __webpack_public_path__ + "images/7bc9a018f595c23a91c5b4a045d2c816.png";